import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Observable} from 'rxjs';
import {OAuthService} from 'angular-oauth2-oidc';
import {Router} from '@angular/router';
import {User} from '../../models/user';
import {AuthenticationService} from '../../services/authentication.service';
import { MediaMatcher } from "@angular/cdk/layout";
import {IdentityConstants} from "../../services/identity.constants";

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss']
})
export class AppLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  private _mobileQueryListener: () => void;
  signedIn: Observable<boolean>;
  name: string;
  roles: string[];
  isAdmin: boolean = false;

  mobileQuery: MediaQueryList;

  constructor(
    public title: Title,
    private oAuthService: OAuthService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
  ) {
    this.mobileQuery = this.media.matchMedia('(max-width: 1000px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    // tslint:disable-next-line: deprecation
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    // tslint:disable-next-line: deprecation
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  ngOnInit() {
    this.title.setTitle('RoadAware Dashboard');

    this.signedIn = this.authenticationService.isSignedIn();

    this.authenticationService.userChanged().subscribe(
      (user: User) => {
        this.name = user.givenName;
        this.roles = user.roles;
        this.isAdmin = this.authenticationService.isInRole(IdentityConstants.AdminRoleName);
      });
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }

  signout(): void {
    this.authenticationService.signout();
    this.router.navigate(['/account/signin']);
  }

}
